import { useAlertStore } from '~/store/alerts'

export default defineNuxtRouteMiddleware(async () => {
  const alertStore = useAlertStore()
  alertStore.$reset()
})
